import { formatDate } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

import { KpiType } from '../../coaching-insight/insight-widget/model/kpi-type.model';
import { I18nService } from '../../i18n/i18n.service';
import { epicDependencies } from '../../store';
import { KpiTypeTranslationMap } from '../constants/kpi-type-translation-map';
import { HeaderRowData } from '../models/header-row-data.model';

export function getHeaderRowData(
    startDate?: Date | string,
    endDate?: Date | string,
    type?: KpiType,
): HeaderRowData {
    const translateService =
        epicDependencies.injector.get<TranslateService>(TranslateService);
    const i18nService = epicDependencies.injector.get<I18nService>(I18nService);
    const userLocale = i18nService.locale;

    const formatWithUTC = (dateInput: Date | string): string => {
        let date: Date;
        if (typeof dateInput === 'string') {
            if (dateInput.includes('T')) {
                date = new Date(dateInput);
            } else {
                // Create a UTC date from a date string without a time part
                const parts = dateInput
                    .split('-')
                    .map((part) => parseInt(part, 10));
                date = new Date(Date.UTC(parts[0], parts[1] - 1, parts[2]));
            }
        } else {
            date = new Date(
                Date.UTC(
                    dateInput.getFullYear(),
                    dateInput.getMonth(),
                    dateInput.getDate(),
                ),
            );
        }
        return formatDate(date, 'MMMM d, yyyy', userLocale, 'UTC');
    };

    let periodDate: string;
    if (startDate == null || endDate == null) {
        periodDate = '';
    } else {
        const startDateFormatted = formatWithUTC(startDate);
        const endDateFormatted = formatWithUTC(endDate);
        periodDate = `${startDateFormatted} - ${endDateFormatted}`;
    }

    const titleLabel = KpiTypeTranslationMap[type];

    return {
        titleLabel: translateService.instant(titleLabel),
        periodDate,
        hasHeaderIcon: false,
    };
}
